import { ArrowUpRight } from "lucide-react";
import { EVIDENCE } from "../../data/content";
import { SectionHeading } from "../common";
import { Reveal } from "../Reveal";

export const Evidence = () => (
    <section className="py-24 md:py-32 border-b border-thg-border bg-[#0d0d0d]" data-testid="evidence-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index="06"
                overline="Work in the World"
                title="Evidence, not adjectives."
                text="Credentials, published research, products in market, and operating businesses."
            />
            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-thg-border border border-thg-border">
                {EVIDENCE.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.08} className="bg-[#0a0a0a] p-8 md:p-10">
                        <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-thg-red">{item.type}</p>
                        <h3 className="mt-4 font-display text-lg md:text-xl font-medium text-white">{item.title}</h3>
                        <p className="mt-3 text-sm leading-relaxed text-thg-secondary">{item.text}</p>
                        {item.href && (
                            <a
                                href={item.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`evidence-link-${i}`}
                                className="mt-5 inline-flex items-center gap-1.5 text-xs tracking-[0.15em] uppercase text-thg-secondary hover:text-white transition-colors duration-300"
                            >
                                Read <ArrowUpRight size={13} />
                            </a>
                        )}
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
